import React from 'react';

const EditableFileFormat = (props: any) => {
  const { color, text } = props;

  return (
    <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4535_58262)">
        <path
          d="M15.8242 1.48813C15.524 1.1794 15.1092 1 14.6734 1H4.09507C2.38578 1 1.00013 2.35433 1.00012 4.02498L1 19.9749C0.999989 21.6456 2.38564 22.9999 4.09494 22.9999L16.9046 23C18.6139 23 19.9995 21.6457 19.9996 19.9751L20 6.13977C20 5.75302 19.849 5.38126 19.5744 5.10283C19.0666 4.58796 18.2186 3.7408 17.6788 3.26875C16.9901 2.66645 16.2754 1.95209 15.8242 1.48813Z"
          fill="#E8E8E8"
        />
        <path
          d="M14.5841 1V5.10283C14.5841 5.93816 15.277 6.61533 16.1316 6.61533H20M17.6788 3.26875C16.9901 2.66645 16.2754 1.95209 15.8242 1.48813C15.524 1.1794 15.1092 1 14.6734 1H4.09507C2.38578 1 1.00013 2.35433 1.00012 4.02498L1 19.9749C0.999989 21.6456 2.38564 22.9999 4.09494 22.9999L16.9046 23C18.6139 23 19.9995 21.6457 19.9996 19.9751L20 6.13977C20 5.75302 19.849 5.38126 19.5744 5.10283C19.0666 4.58796 18.2186 3.7408 17.6788 3.26875Z"
          stroke="#4D4D4D"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <text
          fill={color !== undefined ? color : '#4D4D4D'}
          x="50%"
          y="62%"
          style={{ whiteSpace: 'pre', textTransform: 'uppercase' }}
          textAnchor="middle"
          dominantBaseline={'middle'}
          fontSize="6"
          fontWeight="800"
          letterSpacing="0.06em"
        >
          <tspan>{text !== '' ? text : ''}</tspan>
        </text>
      </g>
      <defs>
        <clipPath id="clip0_4535_58262">
          <rect width="21" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EditableFileFormat;
